import { APP_CONFIG } from '@/config';
import type { NavItem } from '@/types';

import { COMMON_CONTENT } from './common';

export const BREADCRUMB_CONTENT = {
  home: 'Home',
  page: 'Page',
  shop: 'Shop',
} as const;

export const NAV_CONTENT = {
  logo: {
    src: APP_CONFIG.logo,
    text: COMMON_CONTENT.brand.name,
    tagline: COMMON_CONTENT.brand.tagline,
    altText: `${COMMON_CONTENT.brand.name} Logo`,
  },
  items: [
    { id: 'home', label: 'Home', path: '/', icon: 'Home' },
    { id: 'about', label: 'About Us', path: '/about' },
    { id: 'shop-all', label: 'Shop All', path: '/shop', icon: 'ShoppingBag' },
    {
      id: 'more',
      label: 'More',
      path: '#',
      icon: 'Menu',
      children: [
        { id: 'faq', label: 'FAQ', path: '/faq' },
        { id: 'size-guide', label: 'Size Guide', path: '/size-guide' },
        { id: 'care', label: 'Care Instructions', path: '/care-instructions' },
        { id: 'gift-guide', label: 'Gift Guide', path: '/gift-guide' },
        { id: 'shipping-returns', label: 'Shipping Returns', path: '/shipping-returns' },
      ],
    },
    { id: 'contact', label: 'Contact', path: '/contact', icon: 'Mail' },
  ] as NavItem[],
  actions: {
    search: {
      label: 'Search',
      placeholder: COMMON_CONTENT.placeholders.search,
      ariaLabel: 'Open search',
    },
    wishlist: { label: 'Wishlist', ariaLabel: 'View wishlist' },
    cart: { label: 'Cart', ariaLabel: 'View cart' },
    signIn: { label: 'Sign In', ariaLabel: 'Sign in' },
    signOut: { label: 'Sign Out', ariaLabel: 'Sign out' },
    myAccount: { label: 'My Account', ariaLabel: 'My account' },
  },
  childDescription: (label: string) => {
    switch (label) {
      case 'FAQ':
        return 'Frequently asked questions';
      case 'Size Guide':
        return 'Find your perfect fit';
      case 'Care Instructions':
        return 'How to care for your friend';
      case 'Gift Guide':
        return 'Perfect gifts for everyone';
      default:
        return 'Learn more';
    }
  },

  mobile: {
    menuLabel: 'Menu',
    createAccount: 'Create Account',
  },
  userMenu: {
    myAccount: 'My Account',
    signOut: 'Sign Out',
  },
  search: {
    popularSearches: [
      { id: 'teddy', label: 'Teddy Bear' },
      { id: 'bunny', label: 'Bunny' },
      { id: 'unicorn', label: 'Unicorn' },
    ],
    popularSearchesTitle: 'Popular Searches',
  },
} as const;
